const listaDocumentos = [
  {
      value: null,
      text: "-- Seleccione un Tipo --",
      nemo: ""
  },
  {
      value: "1",
      text: "Registro Civil",
      nemo: "RC"
    },
    {
      value: "2",
      text: "Tarjeta de Identidad",
      nemo: "TI"
    },
    {
      value: "3",
      text: "C\u00e9dula de Ciudadan\u00eda",
      nemo: "CC"
    },
    {
      value: "4",
      text: "C\u00e9dula de Extranjer\u00eda",
      nemo: "CE"
    },
    {
      value: "5",
      text: "N\u00famero \u00danico de Identificaci\u00f3n",
      nemo: "NUIP"
    }
  ]
  export default listaDocumentos